export const colTableRef = 'col-data-group';
